export const matchesSimpleString = function(str) {
  return /^[a-zA-Z0-9_\-\.~]{3,}$/.test(str);
}

export const matchesISBNString = function(str) {
  return /^[0-9-]+$/.test(str) && str.length < 18;
}

export const matchesDateString = function(str) {
  return /^[0-9]{4}-(0[1-9]|1[0-2])-([0-2][1-9]|[12]0|3[01])$/.test(str);
}

export const matchesURL = function(str){
  return /^http(s)?:\/\//.test(str)
}

export const validateISBN = function(attr, val) {
  if(attr === 'number') {
    return matchesISBNString(val);
  } else {
    return true;
  }
}

export const validateShortDescription = function (str) {
  return /^[^<>&'"]*$/.test(str) && str.length < 151;
}
